import { unwrap } from "@brad-tipper/app-frontend";
import { api } from "~/api/client";

export type DeletionRequest = { requestedAt: string; scheduledFor: string };
export async function getDeletionRequest(): Promise<DeletionRequest | null> {
  const result = await unwrap(api.getAccountDeletion());
  return result.scheduledFor && result.requestedAt ? { requestedAt: result.requestedAt, scheduledFor: result.scheduledFor } : null;
}
export async function requestDeletion(confirmedEmail: string) {
  const result = await unwrap(api.requestAccountDeletion({ body: { confirmation: "DELETE", email: confirmedEmail.trim() } }));
  return { requestedAt: result.requestedAt!, scheduledFor: result.scheduledFor! };
}
export async function cancelDeletion() { await unwrap(api.cancelAccountDeletion()); }
export async function exportMyData() { return unwrap(api.exportAccount()); }
